var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAddGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 27.325,
    viewBox: "0 0 30 27.325",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "add_a_photo_FILL0_wght400_GRAD0_opsz48_1_",
    "data-name": "add_a_photo_FILL0_wght400_GRAD0_opsz48 (1)",
    d: "M26.723,11.539V8.627H23.811V6.6h2.912V3.65h2.032V6.6H31.7V8.627H28.754v2.912ZM3.732,30.975a1.949,1.949,0,0,1-1.422-.609A1.949,1.949,0,0,1,1.7,28.943V11.573a1.968,1.968,0,0,1,.609-1.405,1.924,1.924,0,0,1,1.422-.626H8.709L11.181,6.6h9.481V8.627H12.129L9.657,11.573H3.732v17.37H26.756V14.722h2.032V28.943a1.924,1.924,0,0,1-.626,1.422,1.968,1.968,0,0,1-1.405.609Zm11.512-4.944A5.668,5.668,0,0,0,21,20.241a5.51,5.51,0,0,0-1.659-4.08,5.6,5.6,0,0,0-4.1-1.642,5.612,5.612,0,0,0-5.756,5.722,5.637,5.637,0,0,0,1.642,4.131A5.551,5.551,0,0,0,15.244,26.031Zm0-2.032a3.593,3.593,0,0,1-2.675-1.067,3.68,3.68,0,0,1-1.05-2.692,3.581,3.581,0,0,1,1.05-2.641,3.623,3.623,0,0,1,2.675-1.05A3.638,3.638,0,0,1,17.9,17.6a3.551,3.551,0,0,1,1.067,2.641A3.649,3.649,0,0,1,17.9,22.933,3.607,3.607,0,0,1,15.244,24ZM15.244,20.275Z",
    transform: "translate(-1.7 -3.65)",
    fill: "#909090",
    opacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAddGrey);
export default __webpack_public_path__ + "static/media/iconAddGrey.904a83f92a839b4377b48457049d7379.svg";
export { ForwardRef as ReactComponent };